import { Bug, History, Inbox, RefreshCw } from "lucide-react";
import { SettingsSubNav, type SettingsSubNavTab } from "./SettingsSubNav";

const logTabs: readonly SettingsSubNavTab[] = [
  { label: "Audit", href: "/dashboard/settings/logs/audit", icon: History },
  { label: "Errors", href: "/dashboard/settings/logs/errors", icon: Bug },
  { label: "Email", href: "/dashboard/settings/logs/email", icon: Inbox },
  { label: "NOS Sync", href: "/dashboard/settings/logs/nos-sync", icon: RefreshCw },
];

/**
 * Settings → Logs: the four read-mostly records of what the system did — who
 * changed what, what broke, what was emailed, and what reached NOS. Grouped
 * because each is consulted while diagnosing something, not while configuring.
 */
export function SettingsLogsLayout({ children }: { children: React.ReactNode }) {
  return (
    <SettingsSubNav tabs={logTabs} section="Logs">
      {children}
    </SettingsSubNav>
  );
}
